import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

export default function ClientTestFormPage() {
  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://server.fillout.com/embed/v1/"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <Layout>
      <section className="pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="w-full h-[80vh] min-h-[700px]">
          <div
            data-fillout-id="j99DLmvRAnus"
            data-fillout-embed-type="fullscreen"
            style={{ width: '100%', height: '100%' }}
            data-fillout-inherit-parameters
          />
        </div>
      </section>
    </Layout>
  );
}